function isDecimal(value: string | number): boolean {
  return !Number.isInteger(parseFloat(value.toString()))
}

function replaceWhiteSpace(value: string, replaceValue = '-'): string {
  return value.replace(/\s+/g, replaceValue)
}

function escape(value: string | number): string | number {
  const valueStr = replaceWhiteSpace(value.toString())
  if (valueStr.includes('\\.')) return value
  return isDecimal(value) ? valueStr.replace('.', `\\.`) : value
}

export function addPrefix(value: string | number, prefix = ''): string {
  return [prefix, escape(value)].filter(Boolean).join('-')
}

export function toVar(value: string, prefix = ''): string {
  return `--${addPrefix(value, prefix)}`
}

export function toVarRef(name: string): string {
  return `var(${escape(name)})`
}

export function toPrefixedVarRef(name: string, prefix = ''): string {
  return toVarRef(toVar(name, prefix))
}

export function toCSSVars(
  obj: Record<string, any>,
  prefix = ''
): Record<string, any> {
  if (!obj) return {}

  const _prefix = prefix ? addPrefix(prefix, 'mote') : 'mote'
  const vars: Record<string, any> = {}

  for (const [key, value] of Object.entries(obj)) {
    if (!value) continue

    if (typeof value === 'object') {
      const nestedVars = toCSSVars(value, addPrefix(key, prefix))
      if (!nestedVars) continue
      for (const [nestedKey, nestedValue] of Object.entries(nestedVars)) {
        vars[nestedKey] = nestedValue
      }
    } else {
      vars[toVar(key, _prefix)] = value
    }
  }

  return vars
}

export function toCSSVarNames(
  obj: Record<string, any>,
  prefix = ''
): Record<string, any> {
  if (!obj) return {}

  const _prefix = prefix ? addPrefix(prefix, 'mote') : 'mote'
  const vars: Record<string, any> = {}

  for (const [key, value] of Object.entries(obj)) {
    if (!value) continue
    if (typeof value === 'object') {
      const nestedVars = toCSSVarNames(value, addPrefix(key, prefix))
      if (!nestedVars) continue
      vars[key] = nestedVars
    } else {
      vars[key] = toVarRef(toVar(key, _prefix))
    }
  }
  return vars
}
